import { LayoutWithNavigationBar } from "../../layouts/layout-with-navigation-bar";
import { MainView } from "../../views/rack-location-backup";

export default function RackLocationBackupPage(props) {
    return (
        <>
            <LayoutWithNavigationBar>
                <MainView />
            </LayoutWithNavigationBar>
        </>
    );
}